import { type ApiResponseFundStructureWithOpportunityId } from "@vega-api/generated/types/apiResponseFundStructureWithOpportunityId";
import { type FundVehicleResponseV2 } from "@vega-api/generated/types/fundVehicleResponseV2";
import { type ShareClassResponseV2 } from "@vega-api/generated/types/shareClassResponseV2";

export const fundVehicleId1 = "23db391c-9270-4033-a30c-a785d8779c47";
export const fundVehicleId2 = "29cd4f45-531c-4d64-a2b4-2a2b57c0960c";
export const shareClassId1 = "29cd4f45-531c-4d64-a2b4-2a2b57c0960c";
export const shareClassId2 = "23db391c-9270-4033-a30c-a785d8779c47";

export const shareClassData: ShareClassResponseV2 = {
  shareClassId: shareClassId1,
  code: "TERMS1",
  name: "Apollo Clean Transition Equity Partners II Co-Investors (A)",
  fundVehicleId: fundVehicleId1,
  attributes: {
    name: {
      attribute: "Apollo Clean Transition Equity Partners II Co-Investors (A)",
      footnotes: [],
      displayNumber: -1,
    },
    lockUp: {
      attribute: undefined,
      footnotes: [],
      displayNumber: -1,
    },
    investorTypes: {
      attribute: ["KNOWLEDGEABLE_EMPLOYEE", "QUALIFIED_PURCHASER"],
      footnotes: [],
      displayNumber: -1,
    },
    nonQualifiedMinimumInvestment: {
      attribute: {
        amount: 125000.0,
        currency: "USD",
      },
      footnotes: [],
      displayNumber: -1,
    },
    nonQualifiedMinimumSubsequentInvestment: {
      attribute: {
        amount: 25000.0,
        currency: "USD",
      },
      footnotes: [],
      displayNumber: -1,
    },
    fees: {
      managementFees: {
        attribute: [
          {
            type: undefined,
            name: "Management Fee",
            structure: undefined,
            paymentFrequency: undefined,
            rate: 0.0,
            feeBasis: undefined,
            applicablePeriod: undefined,
            additionalInformation:
              "Management Fee: none for Employees\nCarried Interest: none for Employees",
          },
        ],
        footnotes: [],
        displayNumber: -1,
      },
      incentiveFees: {
        attribute: [],
        footnotes: [],
        displayNumber: -1,
      },
      additionalFees: {
        attribute: [],
        footnotes: [],
        displayNumber: -1,
      },
      generalPartnerCommitment: {
        attribute: {
          value: 0.025,
        },
        footnotes: [],
        displayNumber: -1,
      },
      catchUp: {
        attribute: 0,
        footnotes: [],
        displayNumber: -1,
      },
      carriedInterestRate: {
        attribute: {
          value: 0.0,
          additionalInformation: "Carried Interest: none for Employees",
        },
        footnotes: [],
        displayNumber: -1,
      },
      hurdleRate: {
        attribute: {
          value: undefined,
        },
        footnotes: [],
        displayNumber: -1,
      },
    },
    dividendTreatment: {
      attribute: {
        dividendTreatment: undefined,
        dividendTreatmentAdditionalInformation: undefined,
      },
      footnotes: [],
      displayNumber: -1,
    },
    distributionSchedule: {
      attribute: undefined,
      footnotes: [],
      displayNumber: -1,
    },
    subscriptionSchedule: {
      attribute: {
        nextSubscriptionDates: [],
        additionalInformation: undefined,
      },
      footnotes: [],
      displayNumber: -1,
    },
    redemptionSchedule: {
      attribute: {
        nextRedemptionDates: [],
        additionalInformation: undefined,
      },
      footnotes: [],
      displayNumber: -1,
    },
    inceptionDate: {
      attribute: "2024-08-01T00:00:00",
      footnotes: [],
      displayNumber: -1,
    },
    redemptionGates: {
      attribute: [],
      footnotes: [],
      displayNumber: -1,
    },
    investorTargetRegion: {
      attribute: ["NORTH_AMERICA", "EUROPE"],
      footnotes: [],
      displayNumber: -1,
    },
    valuationFrequency: {
      attribute: {
        valuationFrequency: "QUARTERLY",
      },
      footnotes: [],
      displayNumber: -1,
    },
    customFields: undefined,
    globalFootnotes: [],
    redemptionScheduleFrequencyWithFootnotes: {
      attribute: undefined,
      footnotes: [],
      displayNumber: -1,
    },
    description: {
      attribute: undefined,
      footnotes: [],
      displayNumber: -1,
    },
    subscriptionScheduleFrequency: {
      attribute: undefined,
      footnotes: [],
      displayNumber: -1,
    },
  },
};

export const shareClassData2: ShareClassResponseV2 = {
  ...shareClassData,
  shareClassId: shareClassId2,
  fundVehicleId: fundVehicleId2,
};

export const fundVehicleData: FundVehicleResponseV2 = {
  fundVehicleId: fundVehicleId1,
  name: {
    attribute:
      "Apollo Clean Transition Equity Partners II Co-Investors (A), L.P.",
    footnotes: [],
    displayNumber: -1,
  },
  code: "ACTE-EMP",
  currency: {
    attribute: "USD",
    footnotes: [],
    displayNumber: -1,
  },
  carryProduct: false,
  fundingStatus: {
    attribute: "OPEN",
    footnotes: [],
    displayNumber: -1,
  },
  isEmployee: true,
  attributes: {
    legalName:
      "Apollo Clean Transition Equity Partners II Co-Investors (A), L.P.",
    description: {
      attribute:
        "Apollo Clean Transition Equity Partners II Co-Investors (A), L.P. : A Delaware limited partnership formed to facilitate investment in Apollo Clean Transition Equity Partners II by certain Apollo employees.",
      footnotes: undefined,
      displayNumber: -1,
    },
    legalEntityIdentifier: undefined,
    jurisdictionState: "DE",
    jurisdictionCountry: "US",
    currency: {
      attribute: "USD",
      footnotes: [],
      displayNumber: -1,
    },
    closingSchedule: {
      attribute: ["2026-01-30T00:00:00"],
      footnotes: undefined,
      displayNumber: -1,
    },
    subscriptionDeadline: "2026-01-30T00:00:00",
    investorTaxDocumentations: ["FORM_K1"],
    footnotes: {},
    globalFootnotes: [
      {
        displayNumber: 15,
        footnotes: [
          "There can be no assurance that the Fund will be successful in achieving its target fund size.",
        ],
      },
      {
        displayNumber: 10,
        footnotes: [
          "The target net return disclosed herein is based on the expected gross return of the underlying assets and various estimations and assumptions (including future events that have not occurred) made at the time of underwriting, along with the impact of expenses of approximately 1.10%. Expected gross returns of the underlying assets are based upon underwriting criteria historically used by Apollo when evaluating potential investments in such asset classes. The target returns contained herein are neither guarantees nor predictions or projections of future performance. There can be no assurance that target returns will be achieved or that Apollo will be successful in implementing its investment strategy. Please refer to the Legal Disclaimer for additional information on target returns and hypothetical performance. The Fund may utilize leverage, which may impact target returns.",
        ],
      },
      {
        displayNumber: 13,
        footnotes: [
          "There can be no assurance that Apollo will be successful in implementing its investment approach or that the Fund will achieve its investment objectives.",
        ],
      },
      {
        displayNumber: -1,
        footnotes: [],
      },
    ],
    targets: {
      targetInternalRateOfReturn: {
        attribute: {
          grossMaximum: undefined,
          grossMinimum: 0.2,
          netMaximum: undefined,
          netMinimum: 0.2,
        },
        footnotes: [
          "The target net return disclosed herein is based on the expected gross return of the underlying assets and various estimations and assumptions (including future events that have not occurred) made at the time of underwriting, along with the impact of expenses of approximately 1.10%. Expected gross returns of the underlying assets are based upon underwriting criteria historically used by Apollo when evaluating potential investments in such asset classes. The target returns contained herein are neither guarantees nor predictions or projections of future performance. There can be no assurance that target returns will be achieved or that Apollo will be successful in implementing its investment strategy. Please refer to the Legal Disclaimer for additional information on target returns and hypothetical performance. The Fund may utilize leverage, which may impact target returns.",
        ],
        displayNumber: 10,
      },
      targetInvestmentSize: {
        attribute: {
          currency: "USD",
          maximum: undefined,
          minimum: undefined,
        },
        footnotes: [],
        displayNumber: -1,
      },
      targetLeverage: {
        attribute: {
          maximum: undefined,
          minimum: undefined,
        },
        footnotes: [],
        displayNumber: -1,
      },
      targetMultipleOnInvestedCapital: {
        attribute: {
          grossMaximum: undefined,
          grossMinimum: undefined,
          netMaximum: undefined,
          netMinimum: undefined,
        },
        footnotes: [],
        displayNumber: -1,
      },
      targetNumberOfInvestments: {
        attribute: {
          maximum: 15.0,
          minimum: 10.0,
        },
        footnotes: [
          "There can be no assurance that Apollo will be successful in implementing its investment approach or that the Fund will achieve its investment objectives.",
        ],
        displayNumber: 13,
      },
      targetReturnOnEquity: {
        attribute: {
          grossMaximum: undefined,
          grossMinimum: undefined,
          netMaximum: undefined,
          netMinimum: undefined,
        },
        footnotes: [],
        displayNumber: -1,
      },
      targetRaise: {
        attribute: {
          amount: 1500000000,
          currency: "USD",
        },
        footnotes: [
          "There can be no assurance that the Fund will be successful in achieving its target fund size.",
        ],
        displayNumber: 15,
      },
    },
    supportContacts: [
      {
        attribute: [
          {
            name: "Clean Transition Marketing Requests",
            email: "cleantransitionmarketingrequests@apollo.com",
            phone: undefined,
          },
        ],
        footnotes: [],
        displayNumber: -1,
      },
    ],
    generalDisclaimerContent: {
      attribute: "<p>Past performance does not guarantee future results.</p>",
      footnotes: [],
      displayNumber: -1,
    },
    estimatedCloseDate: "2025-07-31T00:00:00",
    generalPartnerCommitmentPercentage: 0.025,
    generalPartnerCommitmentWithFootnotes: {
      attribute: {
        value: 0.025,
      },
      footnotes: [],
      displayNumber: -1,
    },
    strategy: {
      attribute:
        '<p>Apollo Clean Transition Equity Partners II ("ACTE II" or the "Fund") is the Firm&rsquo;s dedicated energy transition and decarbonization private equity strategy. The Fund seeks private equity-like returns from investments with downside protections and rights on future capital.</p><p>&nbsp;</p>',
      footnotes: [],
      displayNumber: -1,
    },
    fundingStatus: "OPEN",
    additionalFootnotes: {
      valuationsFootnotes: {
        displayNumber: -1,
        footnote: "",
      },
      performancesFootnotes: {
        displayNumber: -1,
        footnote: "",
      },
    },
  },
  shareClasses: [shareClassData],
};

export const fundVehicleData2: FundVehicleResponseV2 = {
  ...fundVehicleData,
  fundVehicleId: fundVehicleId2,
  shareClasses: [shareClassData2],
};

export const closedEndedFundData: ApiResponseFundStructureWithOpportunityId = {
  meta: undefined,
  errors: undefined,
  data: {
    opportunityId: "89c6f4f0-2884-4d00-9be0-7a9cfde480bc",
    fundStructure: {
      id: "39162122-1762-4e48-8388-eebad5d6e1a2",
      name: {
        attribute: "Apollo Clean Transition Equity Partners II",
        footnotes: [],
        displayNumber: -1,
      },
      code: "ACTE",
      fundType: "CLOSED_ENDED",
      currency: {
        attribute: "USD",
        footnotes: [],
        displayNumber: -1,
      },
      summary: {
        attribute: "Apollo Clean Transition (ACT) Equity Partners II",
        footnotes: [],
        displayNumber: -1,
      },
      reportingDataStatus: "POST_REPORTING",
      openEndedFundType: undefined,
      fundingStatus: {
        attribute: "OPEN",
        footnotes: [],
        displayNumber: -1,
      },
      attributes: {
        name: {
          attribute: "Apollo Clean Transition Equity Partners II",
          footnotes: [],
          displayNumber: -1,
        },
        currency: {
          attribute: "USD",
          footnotes: [],
          displayNumber: -1,
        },
        summary: {
          attribute: "Apollo Clean Transition (ACT) Equity Partners II",
          footnotes: [],
          displayNumber: -1,
        },
        priorVintageCodes: [],
        assetClass: "PRIVATE_EQUITY",
        impactFocusedStrategy: false,
        investmentType: {
          attribute: "FUND",
          footnotes: [],
          displayNumber: -1,
        },
        industries: {
          attribute: ["SUSTAINABILITY"],
          footnotes: [],
          displayNumber: -1,
        },
        investmentStrategies: {
          attribute: ["BUYOUTS"],
          footnotes: [],
          displayNumber: -1,
        },
        geographicalFocusRegions: {
          attribute: ["NORTH_AMERICA", "EUROPE"],
          footnotes: [],
          displayNumber: -1,
        },
        vintageYear: {
          attribute: "2024-01-01T00:00:00",
          footnotes: [],
          displayNumber: -1,
        },
        hardCap: {
          attribute: { amount: 15000000000, currency: "USD" },
          footnotes: [],
          displayNumber: -1,
        },
        productTermYears: {
          attribute: 10.0,
          footnotes: [],
          displayNumber: -1,
        },
        termExtension: {
          attribute: 2.0,
          footnotes: [
            "Term is 10 years, subject to extension of up to 2 additional 1-year periods with the approval of the advisory board",
          ],
          displayNumber: 30,
        },
        additionalFootnotes: {
          characteristicsFootnotes: {
            displayNumber: -1,
            footnote: "",
          },
          compositionsFootnotes: {
            displayNumber: 23,
            footnote:
              '<p>Totals may not sum due to rounding. There is no guarantee that similar allocations or investments will be available in the future. Percentages based on invested capital of investments, excludes fees and expenses. There can be no guarantee that similar investment opportunities or that the investment opportunities identified in the pipeline will be available in the future, consummated, or profitable. Provided for illustrative and discussion purposes only. Represents clean transition-related investments that Apollo has made within the ACT Equity II fund and Apollo Natural Resources ("ANRP") funds (ANRPII and ANRP III), as ACT Equity II is intended to be a successor fund to ANRP III. Clean Transition Track Record is available upon request.</p>',
          },
          fundManagerTeamFootnotes: {
            displayNumber: 24,
            footnote:
              "There can be no guarantee that any of these professionals will remain with Apollo or that past performance of such professionals serves as an indicator of his or her performance or success.",
          },
        },
        globalFootnotes: [
          {
            displayNumber: 30,
            footnotes: [
              "Term is 10 years, subject to extension of up to 2 additional 1-year periods with the approval of the advisory board",
            ],
          },
          {
            displayNumber: 23,
            footnotes: [
              '<p>Totals may not sum due to rounding. There is no guarantee that similar allocations or investments will be available in the future. Percentages based on invested capital of investments, excludes fees and expenses. There can be no guarantee that similar investment opportunities or that the investment opportunities identified in the pipeline will be available in the future, consummated, or profitable. Provided for illustrative and discussion purposes only. Represents clean transition-related investments that Apollo has made within the ACT Equity II fund and Apollo Natural Resources ("ANRP") funds (ANRPII and ANRP III), as ACT Equity II is intended to be a successor fund to ANRP III. Clean Transition Track Record is available upon request.</p>',
            ],
          },
          {
            displayNumber: 24,
            footnotes: [
              "There can be no guarantee that any of these professionals will remain with Apollo or that past performance of such professionals serves as an indicator of his or her performance or success.",
            ],
          },
        ],
        proposedLaunchDate: {
          attribute: {
            proposedLaunchDate: undefined,
            additionalInformation: undefined,
          },
          footnotes: [],
          displayNumber: -1,
        },
      },
      loanEligible: true,
      employeeFund: true,
      isSma: false,
      termsAndConditions: {
        header: "Terms and Conditions",
        body: '<html> <body> <p> Without limiting the foregoing, certain of the Information herein was prepared prior to November 4, 2022, the effective date of Rule 206(4)-1 (the “Marketing Rule”) under the Investment Advisers Act of 1940, as amended, and is provided solely for historical reference purposes only, and such Information is not, and does not purport to be, an offer of Apollo’s investment advisory services with regard to securities to prospective clients or investors in any Apollo Fund or an offer of new investment advisory services with regard to securities to current clients or investors in any Apollo Fund.</p> <p>The Materials (as defined below) have been prepared by Apollo (as defined below) and are confidential and proprietary. In addition, certain of the Materials may contain material nonpublic information. The Materials are being furnished to a limited number of sophisticated investors and/or certain of their Representatives (as defined below), including you, for the sole purpose of providing information about, and documents with respect to, a potential investment in the relevant Apollo-managed fund or product , its parallel funds and any of their feeder funds, as applicable (such fund, the “Apollo Fund” and such potential investment, the “Potential Investment”), &nbsp;in a convenient format in connection with their evaluation of a possible investment by such investors in the Potential Investment and may not be used for any other purpose.<br/> &nbsp;<br/> The “Materials” means (a) the materials provided in this workspace (whether such materials are contained in this workspace as of the date hereof or at any date hereafter), (b) all materials that use, contain, reflect or are derived from or incorporate the materials referred to in clause (a), and (c) all other materials that relate to or contain nonpublic information regarding Apollo Global Management, Inc. (together with its subsidiaries, “Apollo”) and/or its affiliates, including the Apollo Fund, and are provided in connection with the Potential Investment, in each case, whether provided in this workspace or otherwise (for example, by e-mail in hard copy, or orally). For the avoidance of doubt, the “Materials” shall not include (a) information that is or becomes publicly available (other than by breach of the confidentiality agreement by you); (b) information possessed by or in the knowledge of you or your Representatives prior to disclosure by or on behalf of Apollo; (c) information that subsequently becomes available to you or your representatives from a third party who is not prohibited from disclosing the information to you by a contractual or legal obligation; and (d) information independently developed by you or your representatives without reference to the Materials provided by or on behalf of Apollo.<br/> &nbsp;<br/> By clicking “accept” and accessing this workspace, you hereby acknowledge and agree:<br/> &nbsp;<br/> 1) that by gaining access to the Materials, you will be in possession of confidential information, the improper use or disclosure of which could have a material adverse effect on Apollo or upon one or more of its investors, potential investors or current or prospective portfolio companies, assets or investments; references to “confidential information” shall not include (a) information that is or becomes publicly available (other than by breach of the confidentiality agreement by you); (b) information possessed by or in the knowledge of you or your Representatives prior to disclosure by or on behalf of Apollo; (c) information that subsequently becomes available to you or your representatives from a third party who is not prohibited from disclosing the information to you by a contractual or legal obligation; and (d) information independently developed by you or your representatives without reference to the confidential information provided by or on behalf of Apollo;</p> <p> 2) to keep all Materials strictly confidential and to use all reasonable means to protect the Materials against disclosure to, or use by, any unauthorized person (which protections will entail the same degree of reasonable care as you would use to preserve the confidentiality of your own confidential information, unless such disclosure is required by applicable law, rule, regulation or requests of any governmental agency or other regulatory authority (including relevant stock exchanges), governmental rule or regulation, court order, subpoena, legal, administrative or arbitral proceeding or by any regulatory or judicial authority having jurisdiction over you (collectively, “Applicable Law”)); provided, that a Representative may disclose the Materials to its client that is an investor in the Potential Investment in connection with his, her or its evaluation of the Potential Investment, and for no other purpose (personal to such Representative or otherwise);</p> <p >3) to use the Materials for the sole purpose of obtaining information about the Potential Investment and not to reproduce the Materials or to discuss or distribute them with/to others (except as specifically provided below), at any time, in whole or in part, without the prior written consent of Apollo; provided, that a Representative may disclose the Materials to its client that is an investor or potential investor in the Potential Investment in connection with his, her or its evaluation of the Potential Investment, and for no other purpose (personal to such Representative or otherwise);</p> <p > 4) to provide prompt written notice to Apollo of any improper use or disclosure (or any threatened improper use or disclosure) of any of the Materials and to take all reasonable steps to assist Apollo in preventing such disclosure and recover any improperly disclosed Materials to the extent possible;</p> <p > 5) to delete or destroy (a) all copies of any Materials downloaded, scanned, copied, printed or otherwise captured on this workspace or otherwise provided to you, and (b) all materials that use, contain, reflect or are derived from or incorporate the materials referred to in clause (a), &nbsp;if you (or, if you are a Representative, your investor) determine(s) not to participate as an investor in the Potential Investment or if your (or, if you are a Representative, your investor’s) subscription for the Potential Investment is not accepted by the Apollo Fund, to the extent legally permissible under the circumstances pursuant to applicable laws, rules, regulations and bona fide internal document retention policies and procedures;</p> <p > 6) to electronic delivery of the Materials, including the regulatory brochure and brochure supplement of the applicable investment adviser (Form ADV Part 2A and Form ADV Part 2B), paper copies of which are available upon request and which will be considered received by you as of the date of your initial access to this workspace;</p> <p > 7) that by accessing the Materials, you represent that (i) you are, or that you are an authorized Representative of, both an “accredited investor” (as such term is defined in Regulation D of the United States Securities Act of 1933, as amended (the “Securities Act”)) and a “qualified purchaser” (as such term is defined in Section 2(a)(51)(1) of the United States Investment Company Act of 1940, as amended (the “1940 Act”)) or (ii) you are a “knowledgeable employee” within the meaning of Rule 3c-5 of the 1940 Act;</p> <p > 8) that Apollo is entitled to equitable relief, including injunctive relief, in the event of any breach of the provisions of this agreement by you in addition to all other remedies available to Apollo at law or in equity, in any jurisdiction;</p> <p > 9) that Apollo, to the maximum extent permitted by Applicable Law, will not have any liability to you or any of your clients or other third parties based on the Materials, errors therein or omissions therefrom, and you are not entitled to rely on any of the Materials for any reason or purpose whatsoever, except as provided below;&nbsp;</p> <p > 10) that no failure or delay by Apollo in exercising any right, power or privilege hereunder will operate as a waiver thereof, nor will any single or partial exercise thereof preclude any other or further exercise thereof or the exercise of any other right, power, or privilege hereunder; and</p> <p > 11) in the event that you are an attorney, accountant, consultant or other advisor of a prospective investor in the Potential Investment or any such person’s affiliates as well as such person’s and their affiliates’ respective employees, officers, directors, accountants, auditors, custodians and other professional advisers (each, a “Representative”), you hereby represent and warrant that (a) you are accessing the Materials for the sole purpose of assisting such prospective investor in connection with his, her or its evaluation of the Potential Investment, and for no other purpose (personal to such Representative or otherwise), (b) that such prospective investor has, for and with respect to himself, herself or itself, previously clicked “accept” and accessed this workspace and otherwise continues to be bound by the terms and provisions set forth herein, and (c) except as otherwise expressly provided for herein, that you and each of the Representatives are bound by the confidentiality obligations, privacy safeguards and user restrictions set forth herein, as though you were such prospective investor (other than with respect to the agreements and representations set forth in paragraphs 6 and 7 above).<br/> &nbsp;<br/> By clicking “accept” and accessing this workspace, you hereby further acknowledge and agree to the following:<br/> &nbsp;<br/> If you are required by any Applicable Law to disclose any of the Materials other than in connection with routine inspection, inquiries or audits in the ordinary course of your operations, then you will, to the extent permitted by Applicable Law, provide Apollo with prompt written notice prior to such disclosure so that Apollo may seek a protective order or other appropriate remedy (each, a “Protective Measure”), and/or waive compliance with the provisions of this agreement, and you will cooperate in a commercially reasonable manner with Apollo in any effort that Apollo undertakes to obtain a Protective Measure. If such Protective Measure is not obtained, or Apollo waives compliance with the provisions of this agreement, then you will furnish only that minimum portion of the Materials that is required to be disclosed and will use best efforts to obtain reasonably reliable assurance that the disclosed Materials will be accorded confidential treatment to the maximum extent permissible under Applicable Law. To the extent you disclose any Materials, you will promptly notify Apollo of the disclosure, including providing an index of the Materials disclosed.&nbsp;<br/> &nbsp;<br/> Nothing in this workspace under any circumstances shall create an implication that the information contained in any of the Materials is correct or accurate as of any time subsequent to the date specified in the applicable Materials (each, a “Preparation Date”). You agree that neither Apollo nor any other person has made any representation or warranty, express or implied, as to the accuracy of any information contained in the Materials at any time subsequent to the date specified in the Materials, and neither Apollo nor any other person (including any officer, director, member, or representative of Apollo and/or any other their respective affiliates) shall be subject to any liability to you resulting from the Potential Investment or your use of the information contained in the Materials and that no investment decisions may be made on the basis of any information, in each case, other than the Governing Documents and the confidential Private Placement Memorandum of the Apollo Fund, as applicable, and any Materials set forth therein.&nbsp;<br/> &nbsp;<br/> Providing access to this workspace does not constitute an offer to sell, or the solicitation of an offer to buy, any security, product, service or fund interest, but is intended as a convenient method for providing access to the Materials for prospective investors and their Representatives in connection with their evaluation of the Potential Investment. Any other use is prohibited. The purchase of interests in the Potential Investment will be suitable only for sophisticated investors for whom such an investment does not constitute a complete investment program and who understand and are willing to assume the risks involved in the investment program of the Potential Investment, including those risks set forth in the Materials.<br/> &nbsp;<br/> The Materials are for informational purposes only and do not constitute an offer to sell or a solicitation of an offer to buy any interest in the Potential Investment. Interests in the Potential Investment cannot be purchased except by way of a confidential private placement memorandum or similar offering document (as either of them may be supplemented, updated or modified from time to time) or other definitive investment documents. Investment in the Potential Investment may involve significant risks due to, among other things, the nature of the Potential Investment’s investments. In considering any performance information contained in the Materials, prospective investors should understand that an investment in the Potential Investment does not represent an interest in any investment or investment portfolio of any prior, related or other investment fund or account sponsored, managed or advised by Apollo. The Potential Investment consists of newly organized entities which may have no prior operating history or track record as of the Preparation Date of the applicable Materials and/or the date of an investment in the Potential Investment. Information set forth in the Materials respecting prior performance is not indicative of actual results to be obtained by the Potential Investment, and there can be no assurance that the Potential Investment will be able to implement its investment strategy or investment approach, achieve comparable results, that any target results will be met, that it will be able to avoid losses or that investors in the Potential Investment will receive a return of or on their capital. Prospective investors should be aware that they will be required to bear the financial risks of the Potential Investment for an indefinite period of time. Prospective investors should have the financial ability and willingness to accept the risks and lack of liquidity that may be characteristic of the Potential Investment. An investment in the Potential Investment is speculative and should form only part of a complete investment program, and an investor must be able to bear the loss of its entire investment. In addition, including as set forth in the Materials, there are expected to be occasions in which Apollo, the Potential Investment and/or their respective affiliates encounter potential conflicts of interest in connection with the activities of Apollo and/or the Potential Investment and such conflicts of interest may not be resolved in a manner that is favorable to investors in the Potential Investment.&nbsp;<br/> &nbsp;<br/> Prospective investors should not construe the Materials as legal, tax, investment or other advice. Prospective investors should make their own inquiries and investigation of the Potential Investment described in the Materials, including the merits and risks involved and the legality and tax consequences of the Potential Investment, and consult their own advisers as to the Potential Investment and as to legal, tax, investment and related matters concerning an investment in the Potential Investment. The Materials are not intended to be, and must not be taken alone as, the sole basis for an investment decision.<br/> &nbsp;<br/> Certain statements made in the Materials may contain forward-looking statements regarding the Potential Investment’s and, in some cases, a portfolio company’s, asset’s or other investment’s future plans, objectives and expected performance. Forward-looking statements may be identified by the use of terminology including, but not limited to, “may”, “will”, “seek”, “should”, “expect”, “anticipate”, “target”, “project”, “estimate”, “intend”, “continue” or “believe” or the negatives thereof or other variations thereon or comparable terminology. Any such forward-looking statements are based on assumptions that Apollo and/or the applicable portfolio company, asset or other investment (as the case may be) believes are reasonable, but are subject to a wide range of assumptions, risks and uncertainties and, therefore, there can be no assurance that actual events or results or the actual performance of the Potential Investment will not differ materially from those expressed or implied by such forward-looking statements. Apollo does not undertake any obligation to update or revise the forward-looking statements contained in the Materials to reflect events or circumstances occurring after the Preparation Date or the date of the initial distribution of the applicable Materials or to reflect the occurrence of unanticipated events.<br/> You acknowledge and agree that if definitive documentation is executed by or on behalf of you (or, if you are a Representative, your investor) with respect to your (or your investor’s) investment in the Potential Investment and such definitive documentation contains provisions that purport to govern your (or your investor’s) confidentiality obligations with respect to information covered by the Materials, then, except to the extent otherwise provided for in such definitive documentation, the provisions of such definitive documentation shall control in the event of conflict with this agreement.<br/> &nbsp;<br/> You further acknowledge and agree, however, that this agreement does not apply to information covered by any Materials previously, concurrently or subsequently provided to you (or, if you are a Representative, your investor) with respect to any other investment fund or account sponsored, managed or advised by Apollo in which you (or your investor) hold an investment, so long as such information was, is and continues to be governed by the confidentiality obligations under which such Materials were, are or will be disclosed to you (or your investor) (to the extent such obligations are more restrictive or burdensome than those set forth herein).<br/> &nbsp;<br/> You acknowledge and agree that the Materials may constitute material nonpublic information and are proprietary to Apollo. In that regard, you further acknowledge and agree that any misuse or misappropriation of such information could result in damage not only to Apollo but also applicable portfolio companies, assets and other investments, as the case may be, resulting in potential claims against you. You agree that money damages may not be a sufficient remedy for any breach of this agreement by you, and that, in addition to all other remedies, Apollo shall be entitled to seek specific performance and injunctive or other equitable relief as a remedy for any such breach. You agree (i) not to raise as a defense or objection to the request or granting of such relief, and (ii) that any breach of this agreement is or would be compensable by an award of money damages, and you further agree to waive any requirement for the securing or posting of any bond in connection with any such remedy.<br/> &nbsp;&nbsp;<br/> The Materials are provided solely for your private investigation, and do not constitute any solicitation or recommendation by Apollo with respect to the Potential Investment or with respect to any security or investment strategy. &nbsp;You acknowledge that prior to any investment you may make in the Potential Investment, you must execute a subscription agreement in which you will be required to provide information regarding your investment profile. &nbsp;Apollo Global Securities, LLC (“AGS”), the broker-dealer subsidiary of Apollo, will receive such information and may rely on it, including with respect to any suitability, best interest, or other determinations relating to your investment.<br/> Notice to Retail Investors: AGS is the broker-dealer subsidiary of Apollo and the sole service it provides to retail investors is the placement of interests in funds affiliated with Apollo. &nbsp;AGS does not open accounts or give financial advice or make investment recommendations. &nbsp;Important disclosures relating to AGS’ business are contained in this diligence room: &nbsp;AGS’ Form CRS (Customer Relationship Summary) and Regulation Best Interest Disclosure Document. &nbsp;AGS’ Form CRS can also be accessed on FINRA’s BrokerCheck website (brokercheck.finra.org).&nbsp;<br/> ***<br/> If any provision of this agreement is found by a court of competent jurisdiction to be unenforceable, such provision will be deemed limited or deleted to the minimum extent necessary so that the remaining provisions remain in full force and effect.<br/> &nbsp;<br/> This agreement is personal, nonassignable and nontransferable by you, is governed by the internal laws of the State of New York and may be modified only in a written agreement signed by both you and Apollo.<br/> Nothing herein shall prohibit you from reporting possible violations of federal or state laws or regulations to any federal or state governmental agency, including, but not limited to, the Department of Justice, the Securities and Exchange Commission, Congress and any agency Inspector General, or from making other disclosures that are protected under the whistleblower provisions of federal or state laws or regulations, nor shall anything herein require you to notify the Apollo Fund that you have made such reports or disclosures.<br/> &nbsp;<br/> Apollo reserves the right to modify, at any time, any of the terms of the Potential Investment and this agreement, including, but not limited to, the terms of access to and the disclosure of the Materials.</p> <p style="line-height: 108%; margin-bottom: 0.11in"><br/> <br/> </p> </body> </html>',
        url: "documents/default_terms_and_conditions_for_fund.pdf",
      },
      isDummy: false,
      fundVehicles: [fundVehicleData, fundVehicleData],
      globalFootnotes: [
        {
          displayNumber: 30,
          footnotes: [
            "Term is 10 years, subject to extension of up to 2 additional 1-year periods with the approval of the advisory board",
          ],
        },
        {
          displayNumber: 23,
          footnotes: [
            '<p>Totals may not sum due to rounding. There is no guarantee that similar allocations or investments will be available in the future. Percentages based on invested capital of investments, excludes fees and expenses. There can be no guarantee that similar investment opportunities or that the investment opportunities identified in the pipeline will be available in the future, consummated, or profitable. Provided for illustrative and discussion purposes only. Represents clean transition-related investments that Apollo has made within the ACT Equity II fund and Apollo Natural Resources ("ANRP") funds (ANRPII and ANRP III), as ACT Equity II is intended to be a successor fund to ANRP III. Clean Transition Track Record is available upon request.</p>',
          ],
        },
        {
          displayNumber: 24,
          footnotes: [
            "There can be no guarantee that any of these professionals will remain with Apollo or that past performance of such professionals serves as an indicator of his or her performance or success.",
          ],
        },
      ],
    },
  },
};
